import { defineMutator } from "@rocicorp/zero"

import type { MutatorTx } from "../schema"
import type { DeleteVideoArgs, UpdateVideoArgs } from "../types"

export const videoMutators = {
	update: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: UpdateVideoArgs }) => {
			await tx.mutate.videos.update(args)
		},
	),
	delete: defineMutator(
		async ({ tx, args }: { tx: MutatorTx; args: DeleteVideoArgs }) => {
			// Soft delete by setting isDeleted: true and clearing video data
			await tx.mutate.videos.update({
				id: args.id,
				isDeleted: true,
				recordingId: null,
				transcriptError: null,
				transcriptId: null,
				transcriptStatus: null,
				uploadComplete: false,
				videoUrl: null,
			})
		},
	),
}
